import React from 'react';
import { CancelIcon, FilterIconFilled } from '@navi/web-ui/lib/icons';
import {
  Directions,
  Tooltip as TooltipV2,
  TooltipContent,
  TooltipTrigger
} from '../../TooltipV2/TooltipV2';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import styles from './index.module.scss';
import { IActiveFilterButtonProps } from '../types';

const ActiveFilterButton: React.FC<IActiveFilterButtonProps> = ({
  filterCounts,
  filterText,
  onOpenDrawer,
  onClearAll,
  isDisabled = false
}) => (
  <TooltipV2 placement={Directions.BOTTOM}>
    <TooltipTrigger tooltipTriggerClassName="tooltipTriggerWrapper">
      <Button
        variant="secondary"
        onClick={onOpenDrawer}
        disabled={isDisabled}
        className="!opacity-100 !p-0"
      >
        <div className={styles.filterButton}>
          <FilterIconFilled color="var(--blue-base)" className={isDisabled ? 'opacity-70' : ''} />
          <div className="mr-2" />
          <Typography
            variant="h4"
            color="var(--blue-base)"
            className={isDisabled ? 'opacity-70' : ''}
          >
            Filters
          </Typography>
          <Typography variant="h4" color="var(--blue-base)" className="ml-1">
            ({filterCounts.length})
          </Typography>
          <CancelIcon onClick={onClearAll} className="ml-2" />
        </div>
      </Button>
    </TooltipTrigger>
    <TooltipContent className="tooltipWrapper whitespace-pre-line">{filterText}</TooltipContent>
  </TooltipV2>
);

export default ActiveFilterButton;
